import React, { useState } from 'react';
import DateWidget from './DateWidget';
import NumberWidget from './NumberWidget';
import SelectWidget from './SelectWidget';
import SliderWidget from './SliderWidget';
import TextWidget from './TextWidget';

/**
 * Renders the appropriate input widget based on widget config.
 * Displayed in the chat output area when a parameter has a type_ref.
 *
 * Props:
 *   widget: { type: string, ...settings }
 *   label: string (prompt text)
 *   onSubmit: (value: string) => void
 */
const InputWidget = ({ widget, label, onSubmit }) => {
  const [value, setValue] = useState('');

  const handleSubmit = () => {
    onSubmit(value);
  };

  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '12px',
    background: '#f8f9fa',
    borderRadius: '8px',
    border: '1px solid #e0e0e0',
    maxWidth: '80%',
    marginBottom: '10px',
  };

  const labelStyle = {
    fontSize: '0.85rem',
    color: '#555',
    fontWeight: 500,
  };

  const submitStyle = {
    alignSelf: 'flex-end',
    padding: '6px 16px',
    border: 'none',
    borderRadius: '6px',
    background: '#595959',
    color: '#fff',
    cursor: 'pointer',
    fontSize: '0.85rem',
  };

  const widgetType = widget?.type || 'text';

  const renderWidget = () => {
    switch (widgetType) {
      case 'date':
        return <DateWidget settings={widget} value={value} onChange={setValue} />;
      case 'number':
        return <NumberWidget settings={widget} value={value} onChange={setValue} />;
      case 'select':
        return <SelectWidget settings={widget} value={value} onChange={setValue} />;
      case 'slider':
        return <SliderWidget settings={widget} value={value} onChange={setValue} />;
      case 'phone':
      case 'email':
      case 'url':
      case 'text':
      default:
        return <TextWidget settings={widget} value={value} onChange={setValue} />;
    }
  };

  return (
    <div style={containerStyle}>
      <div style={labelStyle}>{label}</div>
      {renderWidget()}
      <button style={submitStyle} onClick={handleSubmit}>Submit</button>
    </div>
  );
};

export default InputWidget;
